import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// Reset scroll to the top on every route change. Without this, React Router
// keeps the previous scroll position, so navigating (e.g. tapping a peptide or
// "Next") can leave you stuck at the bottom of the new page.
export default function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}
